import { PayrollSummary } from '../entities/payroll-summary';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { Injector, Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { InterfacePlame } from '../model/interfacePlame';
import { tap, map, catchError } from '../../../../node_modules/rxjs/operators';
import { Observable } from '../../../../node_modules/rxjs';
import * as FileSaver from 'file-saver';

@Injectable()
export class PayrollSummaryService extends BaseCrudService<PayrollSummary> {

    public uri = '/api/payrollSummary/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance PayrollSummaryService');
    }

    buildSentence(entity?: PayrollSummary, event?: LazyLoadEvent): HttpParams {
    if (entity) {
        let query = '';
        if (entity.fiscalYear && entity.fiscalYear.id) {
            query = query.concat(
                `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
            );
        }
        if (entity.executingUnit && entity.executingUnit.id) {
            query = query.concat(
                `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
            );
        }
        if (entity.month && entity.month.id) {
            query = query.concat(
                `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
            );
        }
        if (entity.employeeType && entity.employeeType.id) {
            query = query.concat(
                `employeeType.id${QueryOperator.Equal}${entity.employeeType.id}${QueryOperator.Split}`
            );
        }

        if (entity.stage) {
            query = query.concat(
                `stage${QueryOperator.Equal}${entity.stage}${QueryOperator.Split}`
            );
        }

        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
    }

    fileGenerationPlame(interfacePlame: InterfacePlame, filname: String): Observable<any> {
        const url = `${this.rutaServidor}${this.uri}interfacePlame`;
        this.spinnerService.showAll();
        return this.httpClient.post(url, interfacePlame, {responseType: 'blob' })
        .pipe(
            map(res =>  {
              this.spinnerService.hideAll();
              let bean = new Blob([res], { type: 'application/txt'});
                    FileSaver.saveAs(bean, filname);
                    return bean;
                }
            ),
            catchError((err, caught) => {
                let resp = 'No se encontraron registros';
                this.spinnerService.hideAll();
                if (err.status == 404)
                this.notificationService.smallBoxWarning('Ventana de Alerta!', resp);
                return new Observable<Blob>();
                }
            )
        );
    }

    totalEmployee(payrollSummaryId: number): Observable<number> {
        const url = `${this.rutaServidor}${this.uri}totalEmployee/${payrollSummaryId}`;
        this.spinnerService.showAll();
        return this.httpClient
          .get<number>(url)
          .pipe(
            tap(response => {
             //console.log(response);
              this.spinnerService.hideAll();
              return response;
            })
          );
      }

    fileGenerationPlameList(interfacePlame: InterfacePlame): Observable<any> {
        const url = `${this.rutaServidor}${this.uri}interfacePlameList`;
        this.spinnerService.showAll();
        return this.httpClient.post(url, interfacePlame)
            .pipe(
                tap(response => {
                    this.spinnerService.hideAll();
                    // console.log(response)
                    return response;
                })
            );
    }
}




// WEBPACK FOOTER //
// ./src/app/core/services/payroll-summary.service.ts